import { jsx as _jsx } from "react/jsx-runtime";
import { $applyNodeReplacement, DecoratorNode } from 'lexical';
export const SLASH_HINT_NODE_TYPE = 'slash-hint';
export class SlashHintNode extends DecoratorNode {
    __hintText;
    static getType() {
        return SLASH_HINT_NODE_TYPE;
    }
    static clone(node) {
        return new SlashHintNode(node.__hintText, node.__key);
    }
    static importJSON(serializedNode) {
        return $applyNodeReplacement(new SlashHintNode(serializedNode.hintText)).updateFromJSON(serializedNode);
    }
    constructor(__hintText, key) {
        super(key);
        this.__hintText = __hintText;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            hintText: this.__hintText,
            type: SLASH_HINT_NODE_TYPE,
        };
    }
    createDOM() {
        const element = document.createElement('span');
        element.style.display = 'inline';
        return element;
    }
    updateDOM() {
        return false;
    }
    getTextContent() {
        return '';
    }
    exportDOM() {
        const element = document.createElement('span');
        element.setAttribute('aria-hidden', 'true');
        return { element };
    }
    static importDOM() {
        return null;
    }
    decorate() {
        return (_jsx("span", { "aria-hidden": true, className: "text-tertiary pointer-events-none select-none whitespace-pre pr-[0.25em]", contentEditable: false, spellCheck: false, children: this.__hintText }));
    }
}
//# sourceMappingURL=SlashHintNode.js.map